module.exports = __webpack_public_path__ + "img/icon1.2d32e2d5.svg";